// src/controllers/egresoDetController.js

import { getEgresoDets, createEgresoDet, updateEgresoDet, deleteEgresoDet } from '../models/egresoDetModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase.js';
import { toasts } from "svelte-toasts";

// Cargar los detalles de un egreso cuando el usuario haga clic en "Ver Detalles"
export async function fetchEgresoDets(egresoCabId) {
  try {
    const response = await getEgresoDets(egresoCabId, 1, 100); // Ajusta la paginación si es necesario
    return response.items;
  } catch (error) {
    console.error("Error fetching egresoDets:", error);
    Swal.fire('Error', 'No se pudieron cargar los detalles del egreso', 'error');
    return [];
  }
}

// Guardar o actualizar un detalle de egreso
export async function saveEgresoDet(egresoDet, currentEgresoDetId) {
  try {
    if (currentEgresoDetId) {
      await updateEgresoDet(currentEgresoDetId, egresoDet);
      toasts.add({
        title: 'Éxito',
        description: 'Detalle de egreso actualizado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createEgresoDet(egresoDet);
      toasts.add({
        title: 'Éxito',
        description: 'Detalle de egreso creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving egresoDet:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el detalle de egreso',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

// Eliminar un detalle de egreso
export async function removeEgresoDet(id) {
  try {
    await deleteEgresoDet(id);
    toasts.add({
      title: 'Éxito',
      description: 'Detalle de egreso eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting egresoDet:", error);
    Swal.fire('Error', 'No se pudo eliminar el detalle de egreso', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'egresoDet'
export function subscribeToEgresoDets(handleSearch) {
  pb.collection('egresoDet').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromEgresoDets() {
  pb.collection('egresoDet').unsubscribe('*');
}

// Buscar detalles de egreso por descripción con paginación
export async function searchEgresoDets(query, egresoCabId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoDet').getList(page, perPage, {
      filter: `descrip ~ "${query}" && egresoCabId = "${egresoCabId}"`,
    });
    return {
      egresoDet: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching egresoDets:", error);
    Swal.fire('Error', 'No se pudo realizar la búsqueda de detalles de egreso', 'error');
    return null;
  }
}